import { render, staticRenderFns } from "./diensten.vue?vue&type=template&id=e137bd80&scoped=true"
import script from "./diensten.vue?vue&type=script&lang=js"
export * from "./diensten.vue?vue&type=script&lang=js"
import style0 from "./diensten.vue?vue&type=style&index=0&id=e137bd80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e137bd80",
  null
  
)

export default component.exports